import Vue from 'vue';

import RoutineProducts from './routine-products/routine-products.vue';

Vue.component(RoutineProducts.name, RoutineProducts);
